export default __webpack_public_path__ + "static/media/volume_mute_black_48dp.77e4f98e.svg";